import Script from 'next/script';
import Button from '@discover-ui/button';
import { isHubSpotConfigured } from '@/lib/analytics/hubspot/client';
import { openConsentPrompt, useConsent, useConsentPromptOpen } from '@/lib/consent';

const HUBSPOT_FORM_EMBED_SRC = 'https://js.hsforms.net/forms/embed/7655225.js';

/**
 * Renders the HubSpot forms embed only once consent allows it; pre-Accept on GDPR it shows a consent prompt instead. Teardown on withdraw/Reject is handled globally by `HubSpotConsent`.
 */
export default function HubSpotSuggestRestaurantForm() {
  const { allowed, hydrated, isGdprRegion, isUndecided } = useConsent();
  const promptOpen = useConsentPromptOpen();
  const configured = isHubSpotConfigured();

  if (allowed && configured) {
    return (
      <>
        <Script
          id="hubspot-embed-7655225"
          src={HUBSPOT_FORM_EMBED_SRC}
          strategy="afterInteractive"
        />
        <div
          className="hs-form-frame" // eslint-disable-line tailwindcss/no-custom-classname
          data-region="na1"
          data-form-id="0d5e8eed-1e29-46fd-a737-d92f97c4a1b5"
          data-portal-id="7655225"
        />
      </>
    );
  }

  // Gate on `hydrated` so an already-accepted diner doesn't see the prompt flash before the consent cookie is read.
  if (isGdprRegion && hydrated && configured) {
    // The global consent banner is already on screen while undecided or re-fired, so only offer the button when it isn't — otherwise the click no-ops and looks broken.
    const bannerOpen = isUndecided || promptOpen;

    return (
      <div className="flex flex-col items-center gap-3 text-center">
        <p className="text-ds-gray-light-700 text-sm leading-normal">
          This form needs cookies to work. Accept cookies to suggest a restaurant.
        </p>
        {!bannerOpen && (
          <Button type="button" kind="normal" scale="md" onClick={() => openConsentPrompt()}>
            Manage cookies
          </Button>
        )}
      </div>
    );
  }

  return null;
}
